/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Promote a ready deployment to become the current deployment for its environment.
 */
export type V1DeploymentsPromoteDeploymentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type V1DeploymentsPromoteDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsPromoteDeploymentRequestBody$outboundSchema:
  z.ZodType<
    V1DeploymentsPromoteDeploymentRequestBody$Outbound,
    z.ZodTypeDef,
    V1DeploymentsPromoteDeploymentRequestBody
  > = z.object({
    deploymentId: z.string(),
  });

export function v1DeploymentsPromoteDeploymentRequestBodyToJSON(
  v1DeploymentsPromoteDeploymentRequestBody:
    V1DeploymentsPromoteDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsPromoteDeploymentRequestBody$outboundSchema.parse(
      v1DeploymentsPromoteDeploymentRequestBody,
    ),
  );
}
